<template>
    <div class="checkout-delivery-fields">
        <DefInput
            v-for="item in getDeliveryProps"
            :placeholder="item.NAME"
            :required="item.REQUIRED === 'Y'"
            :value="requestData[item.inputName]"
            @change="handlerInputField(item.inputName, $event.target.value)"
        />
<!--        <DefInput-->
<!--            @change="handlerInputField('ORDER_DESCRIPTION', $event.target.value)"-->
<!--            :placeholder="messages.comment"-->
<!--        />-->
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DefInput from "../../../def/DefInput/DefInput";

export default {
    name: 'CheckoutDeliveryFields',
    components: {
        DefInput,
    },
    computed: {
        ...mapState({
            deliveryProps: ({ checkout }) => checkout.data.vue.delivery.props,
            messages: ({ checkout }) => checkout.data.vue?.delivery?.messages,
            requestData: ({ checkout }) => checkout.data.vue?.requestData,
        }),
        getDeliveryProps() {
            return Object?.values(this.deliveryProps)?.filter(el => el.CODE !== 'CITY');
        }
    },
    methods: {
        ...mapMutations({
            setRequestData: 'checkout/setRequestData',
        }),
        handlerInputField(name, value) {
            this.setRequestData({ name, value});
        }
    }
}
</script>

<style lang="scss" scoped>
.checkout-delivery-fields{
    display: grid;
    grid-gap: 8px;
    @include point-md{
        grid-template-columns: 356px repeat(2, 1fr);
    }
    @include point-lg{
        grid-template-columns: 400px 1fr;
    }
    @include point-xl{
        grid-template-columns: 400px repeat(2, 1fr);
    }
    :deep(.def-input){
        height: auto;
    }
}
</style>